/**
 * TO CARTESIAN
 * ===================
 */

export const geoToCartesian = ({ lat, lon, r }) => {
    const DEG2RAD = Math.PI / 180
    const latRad = lat * DEG2RAD,
        lonRad = lon * DEG2RAD
    return {
        x: r * Math.cos(latRad) * Math.cos(lonRad),
        y: r * Math.cos(latRad) * Math.sin(lonRad),
        z: r * Math.sin(latRad),
    }
}

export const sphericalToCartesian = ({ theta, phi, r }) => {
    return {
        x: r * Math.sin(phi) * Math.cos(theta),
        y: r * Math.sin(phi) * Math.sin(theta),
        z: r * Math.cos(phi),
    }
}

export const geoDegRightToLeftCart = ({ lon, lat, r }) => {
    const RAD2DEG = 180 / Math.PI
    const DEG2RAD = Math.PI / 180
    var phi = (90 - lat) * DEG2RAD
    var theta = (lon + 180) * DEG2RAD

    return {
        x: -(r * Math.sin(phi) * Math.sin(theta)),
        y: r * Math.cos(phi),
        z: r * Math.sin(phi) * Math.cos(theta),
    }
}

export const leftToRightGeoToCart = ({ lon, lat, r }) => {
    return {
        x: -(r * Math.sin(lat)),
        y: r * Math.cos(lat) * Math.cos(lon),
        z: r * Math.cos(lat) * Math.sin(lon),
    }
}
export const rightToLeftGeoToCart = ({ lon, lat, r }) => {
    return {
        x: r * Math.cos(lat) * Math.sin(lon),
        y: r * Math.sin(lat),
        z: -(r * Math.cos(lat) * Math.cos(lon)),
    }
}

export const leftToRightCart = ({ x, y, z }) => {
    return {
        x: -z,
        y: x,
        z: y,
    }
}
export const rightToLeftCart = ({ x, y, z }) => {
    return {
        x: y,
        y: z,
        z: -x,
    }
}

/**
 * TO SPHERICAL
 * ===================
 */

export const cartesianToSpherical = ({ x, y, z }) => {
    const r = Math.sqrt(x * x + y * y + z * z)
    const phi = Math.acos(z / r)
    const theta = Math.atan2(y, x)
    return {
        r,
        phi,
        theta,
    }
}

/**
 * TO GEO(rad -> deg)
 * ===================
 */

export const cartesianToGeo = ({ x, y, z }) => {
    const RAD2DEG = 180 / Math.PI
    const r = Math.sqrt(x * x + y * y + z * z)
    const lat = Math.asin(z / r)
    const lon = Math.atan2(y, x)
    const latDeg = lat * RAD2DEG
    const lonDeg = lon * RAD2DEG
    return {
        r,
        lat: latDeg,
        lon: lonDeg,
    }
}

/**
 * TO CAMERA (y->z, z->y)
 * tags: coordinates axes right hand left hand camera convert conversion flip
 */
export const cartesianToCameraGeo = ({ x, y, z }) => {
    return cartesianToGeo({ x, y: z, z: y })
}
export const cameraGeoToCartesian = ({ lat, lon, r }) => {
    const { x, y: z, z: y } = geoToCartesian({ lat, lon, r })
    return { x, y, z }
}
